exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ":host /deep/ .payor-require angular2-multiselect .selected-list .c-btn {\n  border-left: 2px solid #dc3545 !important; }\n\n:host /deep/ angular2-multiselect span {\n  position: relative; }\n\n:host /deep/ angular2-multiselect .selected-list .c-btn {\n  margin-top: -2px;\n  border-radius: 0px; }\n\n:host /deep/ .style-btn-clear-input {\n  position: absolute;\n  cursor: pointer;\n  width: 17px; }\n  :host /deep/ .style-btn-clear-input:hover {\n    color: #e90000; }\n  :host /deep/ .style-btn-clear-input .icon-x-filter {\n    position: absolute;\n    font-size: 10px;\n    right: 2px;\n    top: 4px; }\n\n:host /deep/ .input-switch-custom {\n  margin-top: -2px; }\n\n:host /deep/ .row-qty {\n  margin-top: 2px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/billing-general/billed/billed.component.scss
// module id = 1959
// module chunks = 66